import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { RegisterUserRequest } from '$/requests/RegisterUser.ts';

const useRegisterUser = () => {
  const client = supabaseClient;

  const mutationFn = async (request: RegisterUserRequest) => {
    return registerUser(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useRegisterUser;

async function registerUser(
  client: SupabaseClient,
  request: RegisterUserRequest
): Promise<BackendSuccessResponse<{ message: string }>> {
  const { data, error } = await client.functions.invoke('register_user', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  return data;
}
